(function() {
  if (window._skGiftInit) return;
  window._skGiftInit = true;

  const G1 = 57497224741208;
  const G2 = 57497224708440;
  const T1 = 3000;  // €30 in cents
  const T2 = 7500;  // €75 in cents
  let busy = false;
  let timer;

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 700);
  }

  async function sync() {
    if (busy) return;
    busy = true;
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const gIds = [G1, G2];
      const total = cart.items
        .filter(i => !gIds.includes(Number(i.variant_id)))
        .reduce((s, i) => s + i.final_line_price, 0);

      const h1 = cart.items.some(i => Number(i.variant_id) === G1);
      const h2 = cart.items.some(i => Number(i.variant_id) === G2);
      const w1 = total >= T1;
      const w2 = total >= T2;
      let changed = false;

      if (w1 && !h1) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: G1, quantity: 1 })
        });
        changed = true;
      }
      if (w2 && !h2) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: G2, quantity: 1 })
        });
        changed = true;
      }

      const upd = {};
      if (!w1 && h1) { upd[String(G1)] = 0; changed = true; }
      if (!w2 && h2) { upd[String(G2)] = 0; changed = true; }
      if (Object.keys(upd).length) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: upd })
        });
      }

      if (changed) {
        const data = await fetch('/?sections=mini-cart,cart-icon-bubble,mobile-cart-icon-bubble').then(r => r.json());
        const parse = html => new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section')?.innerHTML || '';
        const mc = document.getElementById('mini-cart');
        if (mc && data['mini-cart']) mc.innerHTML = parse(data['mini-cart']);
        const cib = document.getElementById('cart-icon-bubble');
        if (cib && data['cart-icon-bubble']) cib.innerHTML = data['cart-icon-bubble'];
        const mcib = document.getElementById('mobile-cart-icon-bubble');
        if (mcib && data['mobile-cart-icon-bubble']) mcib.innerHTML = data['mobile-cart-icon-bubble'];
      }
    } catch (e) {
      console.error('[SK Gift]', e);
    } finally {
      busy = false;
    }
  }

  // Intercept fetch
  const _origFetch = window.fetch;
  window.fetch = function(...args) {
    const result = _origFetch.apply(this, args);
    if (!busy) {
      const url = typeof args[0] === 'string' ? args[0] : (args[0] instanceof Request ? args[0].url : '');
      if (/\/cart\/(change|add|update)(\.js)?/.test(url)) {
        result.then(() => schedule()).catch(() => {});
      }
    }
    return result;
  };

  // Intercept XHR fallback
  const _origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    if (!busy && typeof url === 'string' && /\/cart\/(change|add|update)/.test(url)) {
      this.addEventListener('load', () => schedule());
    }
    return _origOpen.apply(this, arguments);
  };

  document.addEventListener('cartdrawer:opened', schedule);
  document.addEventListener('cart:updated', schedule);

  // Run once on load
  schedule();
})();